import { useEffect, useState } from 'react'

import { onlineManager } from '@tanstack/react-query'
import i18n from 'i18next'

import { Toast } from 'src/app/core/services/toast'

interface IUseNetworkStatusReturn {
  isOnline: boolean
}

export const useNetworkStatus = (): IUseNetworkStatusReturn => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)

  useEffect(() => {
    onlineManager.setEventListener(setOnline => {
      const handleOnline = (): void => setOnline(true)
      const handleOffline = (): void => setOnline(false)
      window.addEventListener('online', handleOnline)
      window.addEventListener('offline', handleOffline)
      return () => {
        window.removeEventListener('online', handleOnline)
        window.removeEventListener('offline', handleOffline)
      }
    })

    const handleOnline = (): void => {
      setIsOnline(true)
      onlineManager.setOnline(true)
    }

    const handleOffline = (): void => {
      setIsOnline(false)
      onlineManager.setOnline(false)
      Toast.notify({
        message: i18n.t('errors.offline'),
        type: Toast.toastType.WARNING,
      })
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return { isOnline }
}

export const NetworkStatusProvider = (): null => {
  useNetworkStatus()
  return null
}
